// getBackendErrorMessage - возвращает локализованное сообщение об ошибке бэкенда
export const getBackendErrorMessage = (error, fallbackMessage = 'Something went wrong') => {
    const response = error?.response?.data?.response ?? error?.response?.data ?? error?.response;
    const message = response?.error || response?.message || error?.message;
    if (!message) {
        return fallbackMessage;
    }

    const code = response?.code;
    const messageKey = code ? `${code}:${message}` : message;
    const localizedMessage = backendErrorMessageMap[messageKey] || backendErrorMessageMap[message];

    return localizedMessage || message || fallbackMessage;
};

// Карта локализаций сообщений бэкенда.
const backendErrorMessageMap = {
    'ERR_VALIDATION:player hint balance is not enough': 'Not enough hints',
    'player hint balance is not enough': 'Not enough hints',
    'ERR_VALIDATION:no hints left': 'No hints left in this game',
    'no hints left': 'No hints left in this game',
    'ERR_WRONG_GAME_STATUS:game not found or not active': 'No active game found',
    'game not found or not active': 'No active game found',
    'ERR_WRONG_GAME_STATUS:game is already finished': 'Game is already finished',
    'game is already finished': 'Game is already finished',
    'ERR_WRONG_GAME_STATUS:game not found': 'Game not found',
    'game not found': 'Game not found'
};
